import { QUICK_FILTER_PAGE_IDS } from "../quickFilterUtils";
import { createDummyMetricPresets } from "./createDummyMetricPresets";

/** @type {Record<string, ReturnType<typeof createDummyMetricPresets>>} */
const PRODUCT_ANALYTICS_PRESETS = {
  amazon: createDummyMetricPresets(
    QUICK_FILTER_PAGE_IDS.PRODUCT_ANALYTICS,
    "amazon",
    {
      spend: "VariantAnalysisTablePPMPlaceholder.cost",
      roas: "VariantAnalysisTablePPMPlaceholder.roas",
      orders: "VariantAnalysisTablePPMPlaceholder.conversions14d",
    }
  ),
  myntra: createDummyMetricPresets(
    QUICK_FILTER_PAGE_IDS.PRODUCT_ANALYTICS,
    "myntra",
    { spend: "spends", roas: "roas", orders: "orders" }
  ),
  flipkart: createDummyMetricPresets(
    QUICK_FILTER_PAGE_IDS.PRODUCT_ANALYTICS,
    "flipkart",
    { spend: "spends", roas: "roas", orders: "orders" }
  ),
};

export default PRODUCT_ANALYTICS_PRESETS;
